// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:where(.vuetify-styles) .v-expansion-panel {
  background-color: rgb(var(--v-theme-surface));
  color: rgba(var(--v-theme-on-surface), var(--v-high-emphasis-opacity));
}
:where(.vuetify-styles) .v-expansion-panel:not(:first-child)::after {
  border-color: rgba(var(--v-border-color), var(--v-border-opacity));
}
:where(.vuetify-styles) .v-expansion-panel--disabled .v-expansion-panel-title {
  color: rgba(var(--v-theme-on-surface), 0.26);
}
:where(.vuetify-styles) .v-expansion-panel--disabled .v-expansion-panel-title .v-expansion-panel-title__overlay {
  opacity: 0.4615384615;
}

:where(.vuetify-styles) .v-expansion-panels {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  list-style-type: none;
  padding: 0;
  width: 100%;
  position: relative;
  z-index: 1;
}
:where(.vuetify-styles) .v-expansion-panels:not(.v-expansion-panels--variant-accordion) > :not(:first-child):not(:last-child):not(.v-expansion-panel--active):not(.v-expansion-panel--before-active) {
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}
:where(.vuetify-styles) .v-expansion-panels:not(.v-expansion-panels--variant-accordion) > :not(:first-child):not(:last-child):not(.v-expansion-panel--active):not(.v-expansion-panel--after-active) {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}
:where(.vuetify-styles) .v-expansion-panels:not(.v-expansion-panels--variant-accordion) > :first-child:not(:last-child):not(.v-expansion-panel--active):not(.v-expansion-panel--before-active) {
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}
:where(.vuetify-styles) .v-expansion-panels:not(.v-expansion-panels--variant-accordion) > :last-child:not(:first-child):not(.v-expansion-panel--active):not(.v-expansion-panel--after-active) {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}
:where(.vuetify-styles) .v-expansion-panels--variant-accordion > :first-child:not(:last-child) {
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}
:where(.vuetify-styles) .v-expansion-panels--variant-accordion > :last-child:not(:first-child) {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}
:where(.vuetify-styles) .v-expansion-panels--variant-accordion > :last-child:not(:first-child) .v-expansion-panel-title--active {
  border-bottom-left-radius: initial;
  border-bottom-right-radius: initial;
}
:where(.vuetify-styles) .v-expansion-panels--variant-accordion > :not(:first-child):not(:last-child) {
  border-radius: 0 !important;
}
:where(.vuetify-styles) .v-expansion-panels--variant-accordion .v-expansion-panel-title__overlay {
  transition: 0.3s border-radius cubic-bezier(0.4, 0, 0.2, 1);
}

:where(.vuetify-styles) .v-expansion-panel {
  flex: 1 0 100%;
  max-width: 100%;
  position: relative;
  transition: 0.3s all cubic-bezier(0.4, 0, 0.2, 1);
  transition-property: margin-top, border-radius, border, max-width;
  border-radius: 4px;
}
@media (prefers-reduced-motion: reduce) {
  :where(.vuetify-styles) .v-expansion-panel {
    transition-property: border-radius, border;
  }
}
:where(.vuetify-styles) .v-expansion-panel:not(:first-child)::after {
  border-top-style: solid;
  border-top-width: thin;
  content: "";
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  transition: 0.3s opacity cubic-bezier(0.4, 0, 0.2, 1);
}
:where(.vuetify-styles) .v-expansion-panel--disabled .v-expansion-panel-title {
  pointer-events: none;
}
:where(.vuetify-styles) .v-expansion-panel--active:not(:first-child),
:where(.vuetify-styles) .v-expansion-panel--active + .v-expansion-panel {
  margin-top: 16px;
}
:where(.vuetify-styles) .v-expansion-panel--active:not(:first-child)::after,
:where(.vuetify-styles) .v-expansion-panel--active + .v-expansion-panel::after {
  opacity: 0;
}
:where(.vuetify-styles) .v-expansion-panel--active > .v-expansion-panel-title {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
:where(.vuetify-styles) .v-expansion-panel--active > .v-expansion-panel-title:not(.v-expansion-panel-title--static) {
  min-height: 64px;
}

:where(.vuetify-styles) .v-expansion-panel__shadow {
  border-radius: inherit;
  z-index: -1;
}
:where(.vuetify-styles) .v-expansion-panel__shadow {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
:where(.vuetify-styles) .v-expansion-panel__shadow {
  box-shadow: 0px 3px 1px -2px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 2px 2px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 1px 5px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));
}

:where(.vuetify-styles) .v-expansion-panel-title {
  align-items: center;
  text-align: start;
  border-radius: inherit;
  display: flex;
  font-size: 0.9375rem;
  line-height: 1;
  min-height: 48px;
  outline: none;
  padding: 16px 24px;
  position: relative;
  width: 100%;
  justify-content: space-between;
}
@media (prefers-reduced-motion: no-preference) {
  :where(.vuetify-styles) .v-expansion-panel-title {
    transition: 0.3s min-height cubic-bezier(0.4, 0, 0.2, 1);
  }
}
:where(.vuetify-styles) .v-expansion-panel-title:hover > .v-expansion-panel-title__overlay {
  opacity: calc(var(--v-hover-opacity) * var(--v-theme-overlay-multiplier));
}
:where(.vuetify-styles) .v-expansion-panel-title:focus-visible > .v-expansion-panel-title__overlay {
  opacity: calc(var(--v-focus-opacity) * var(--v-theme-overlay-multiplier));
}
@supports not selector(:focus-visible) {
  :where(.vuetify-styles) .v-expansion-panel-title:focus > .v-expansion-panel-title__overlay {
    opacity: calc(var(--v-focus-opacity) * var(--v-theme-overlay-multiplier));
  }
}
:where(.vuetify-styles) .v-expansion-panel-title--focusable.v-expansion-panel-title--active .v-expansion-panel-title__overlay {
  opacity: calc(var(--v-activated-opacity) * var(--v-theme-overlay-multiplier));
}
:where(.vuetify-styles) .v-expansion-panel-title--focusable.v-expansion-panel-title--active:hover .v-expansion-panel-title__overlay {
  opacity: calc((var(--v-activated-opacity) + var(--v-hover-opacity)) * var(--v-theme-overlay-multiplier));
}
:where(.vuetify-styles) .v-expansion-panel-title--focusable.v-expansion-panel-title--active:focus-visible .v-expansion-panel-title__overlay {
  opacity: calc((var(--v-activated-opacity) + var(--v-focus-opacity)) * var(--v-theme-overlay-multiplier));
}
@supports not selector(:focus-visible) {
  :where(.vuetify-styles) .v-expansion-panel-title--focusable.v-expansion-panel-title--active:focus .v-expansion-panel-title__overlay {
    opacity: calc((var(--v-activated-opacity) + var(--v-focus-opacity)) * var(--v-theme-overlay-multiplier));
  }
}

:where(.vuetify-styles) .v-expansion-panel-title__overlay {
  background-color: currentColor;
  border-radius: inherit;
  opacity: 0;
}
:where(.vuetify-styles) .v-expansion-panel-title__overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

:where(.vuetify-styles) .v-expansion-panel-title__icon {
  display: inline-flex;
  margin-bottom: -4px;
  margin-top: -4px;
  -webkit-user-select: none;
          user-select: none;
  margin-inline-start: auto;
}

:where(.vuetify-styles) .v-expansion-panel-text {
  display: flex;
}
:where(.vuetify-styles) .v-expansion-panel-text__wrapper {
  padding: 8px 24px 16px;
  flex: 1 1 auto;
  max-width: 100%;
}

:where(.vuetify-styles) .v-expansion-panels--variant-accordion > .v-expansion-panel {
  margin-top: 0;
}
:where(.vuetify-styles) .v-expansion-panels--variant-accordion > .v-expansion-panel::after {
  opacity: 1;
}

:where(.vuetify-styles) .v-expansion-panels--variant-popout > .v-expansion-panel {
  max-width: calc(100% - 32px);
}
:where(.vuetify-styles) .v-expansion-panels--variant-popout > .v-expansion-panel--active {
  max-width: calc(100% + 16px);
}

:where(.vuetify-styles) .v-expansion-panels--variant-inset > .v-expansion-panel {
  max-width: 100%;
}
:where(.vuetify-styles) .v-expansion-panels--variant-inset > .v-expansion-panel--active {
  max-width: calc(100% - 32px);
}

:where(.vuetify-styles) .v-expansion-panels--flat > .v-expansion-panel::after {
  border-top: none;
}
:where(.vuetify-styles) .v-expansion-panels--flat > .v-expansion-panel .v-expansion-panel__shadow {
  display: none;
}

:where(.vuetify-styles) .v-expansion-panels--tile {
  border-radius: 0;
}
:where(.vuetify-styles) .v-expansion-panels--tile > .v-expansion-panel {
  border-radius: 0;
}`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/lib/components/VExpansionPanel/VExpansionPanel.css"],"names":[],"mappings":"AAAA;EACE,6CAA6C;EAC7C,sEAAsE;AACxE;AACA;EACE,kEAAkE;AACpE;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,uCAAuC;EACvC,wCAAwC;AAC1C;AACA;EACE,oCAAoC;EACpC,qCAAqC;AACvC;AACA;EACE,uCAAuC;EACvC,wCAAwC;AAC1C;AACA;EACE,oCAAoC;EACpC,qCAAqC;AACvC;AACA;EACE,uCAAuC;EACvC,wCAAwC;AAC1C;AACA;EACE,oCAAoC;EACpC,qCAAqC;AACvC;AACA;EACE,kCAAkC;EAClC,mCAAmC;AACrC;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2DAA2D;AAC7D;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,iDAAiD;EACjD,iEAAiE;EACjE,kBAAkB;AACpB;AACA;EACE;IACE,0CAA0C;EAC5C;AACF;AACA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,WAAW;EACX,OAAO;EACP,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,qDAAqD;AACvD;AACA;EACE,oBAAoB;AACtB;AACA;;EAEE,gBAAgB;AAClB;AACA;;EAEE,UAAU;AACZ;AACA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;AACd;AACA;EACE,uOAAuO;AACzO;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,sBAAsB;EACtB,aAAa;EACb,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,8BAA8B;AAChC;AACA;EACE;IACE,wDAAwD;EAC1D;AACF;AACA;EACE,yEAAyE;AAC3E;AACA;EACE,yEAAyE;AAC3E;AACA;EACE;IACE,yEAAyE;EAC3E;AACF;AACA;EACE,6EAA6E;AAC/E;AACA;EACE,wGAAwG;AAC1G;AACA;EACE,wGAAwG;AAC1G;AACA;EACE;IACE,wGAAwG;EAC1G;AACF;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;EACtB,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAiB;UAAjB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;AACA;EACE,sBAAsB;EACtB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;AACA;EACE,UAAU;AACZ;;AAEA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;;AAEA;EACE,eAAe;AACjB;AACA;EACE,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB","sourcesContent":[".v-expansion-panel {\n  background-color: rgb(var(--v-theme-surface));\n  color: rgba(var(--v-theme-on-surface), var(--v-high-emphasis-opacity));\n}\n.v-expansion-panel:not(:first-child)::after {\n  border-color: rgba(var(--v-border-color), var(--v-border-opacity));\n}\n.v-expansion-panel--disabled .v-expansion-panel-title {\n  color: rgba(var(--v-theme-on-surface), 0.26);\n}\n.v-expansion-panel--disabled .v-expansion-panel-title .v-expansion-panel-title__overlay {\n  opacity: 0.4615384615;\n}\n\n.v-expansion-panels {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  list-style-type: none;\n  padding: 0;\n  width: 100%;\n  position: relative;\n  z-index: 1;\n}\n.v-expansion-panels:not(.v-expansion-panels--variant-accordion) > :not(:first-child):not(:last-child):not(.v-expansion-panel--active):not(.v-expansion-panel--before-active) {\n  border-bottom-left-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n.v-expansion-panels:not(.v-expansion-panels--variant-accordion) > :not(:first-child):not(:last-child):not(.v-expansion-panel--active):not(.v-expansion-panel--after-active) {\n  border-top-left-radius: 0 !important;\n  border-top-right-radius: 0 !important;\n}\n.v-expansion-panels:not(.v-expansion-panels--variant-accordion) > :first-child:not(:last-child):not(.v-expansion-panel--active):not(.v-expansion-panel--before-active) {\n  border-bottom-left-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n.v-expansion-panels:not(.v-expansion-panels--variant-accordion) > :last-child:not(:first-child):not(.v-expansion-panel--active):not(.v-expansion-panel--after-active) {\n  border-top-left-radius: 0 !important;\n  border-top-right-radius: 0 !important;\n}\n.v-expansion-panels--variant-accordion > :first-child:not(:last-child) {\n  border-bottom-left-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n.v-expansion-panels--variant-accordion > :last-child:not(:first-child) {\n  border-top-left-radius: 0 !important;\n  border-top-right-radius: 0 !important;\n}\n.v-expansion-panels--variant-accordion > :last-child:not(:first-child) .v-expansion-panel-title--active {\n  border-bottom-left-radius: initial;\n  border-bottom-right-radius: initial;\n}\n.v-expansion-panels--variant-accordion > :not(:first-child):not(:last-child) {\n  border-radius: 0 !important;\n}\n.v-expansion-panels--variant-accordion .v-expansion-panel-title__overlay {\n  transition: 0.3s border-radius cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.v-expansion-panel {\n  flex: 1 0 100%;\n  max-width: 100%;\n  position: relative;\n  transition: 0.3s all cubic-bezier(0.4, 0, 0.2, 1);\n  transition-property: margin-top, border-radius, border, max-width;\n  border-radius: 4px;\n}\n@media (prefers-reduced-motion: reduce) {\n  .v-expansion-panel {\n    transition-property: border-radius, border;\n  }\n}\n.v-expansion-panel:not(:first-child)::after {\n  border-top-style: solid;\n  border-top-width: thin;\n  content: \"\";\n  left: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n  transition: 0.3s opacity cubic-bezier(0.4, 0, 0.2, 1);\n}\n.v-expansion-panel--disabled .v-expansion-panel-title {\n  pointer-events: none;\n}\n.v-expansion-panel--active:not(:first-child),\n.v-expansion-panel--active + .v-expansion-panel {\n  margin-top: 16px;\n}\n.v-expansion-panel--active:not(:first-child)::after,\n.v-expansion-panel--active + .v-expansion-panel::after {\n  opacity: 0;\n}\n.v-expansion-panel--active > .v-expansion-panel-title {\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.v-expansion-panel--active > .v-expansion-panel-title:not(.v-expansion-panel-title--static) {\n  min-height: 64px;\n}\n\n.v-expansion-panel__shadow {\n  border-radius: inherit;\n  z-index: -1;\n}\n.v-expansion-panel__shadow {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n.v-expansion-panel__shadow {\n  box-shadow: 0px 3px 1px -2px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 2px 2px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 1px 5px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));\n}\n\n.v-expansion-panel-title {\n  align-items: center;\n  text-align: start;\n  border-radius: inherit;\n  display: flex;\n  font-size: 0.9375rem;\n  line-height: 1;\n  min-height: 48px;\n  outline: none;\n  padding: 16px 24px;\n  position: relative;\n  width: 100%;\n  justify-content: space-between;\n}\n@media (prefers-reduced-motion: no-preference) {\n  .v-expansion-panel-title {\n    transition: 0.3s min-height cubic-bezier(0.4, 0, 0.2, 1);\n  }\n}\n.v-expansion-panel-title:hover > .v-expansion-panel-title__overlay {\n  opacity: calc(var(--v-hover-opacity) * var(--v-theme-overlay-multiplier));\n}\n.v-expansion-panel-title:focus-visible > .v-expansion-panel-title__overlay {\n  opacity: calc(var(--v-focus-opacity) * var(--v-theme-overlay-multiplier));\n}\n@supports not selector(:focus-visible) {\n  .v-expansion-panel-title:focus > .v-expansion-panel-title__overlay {\n    opacity: calc(var(--v-focus-opacity) * var(--v-theme-overlay-multiplier));\n  }\n}\n.v-expansion-panel-title--focusable.v-expansion-panel-title--active .v-expansion-panel-title__overlay {\n  opacity: calc(var(--v-activated-opacity) * var(--v-theme-overlay-multiplier));\n}\n.v-expansion-panel-title--focusable.v-expansion-panel-title--active:hover .v-expansion-panel-title__overlay {\n  opacity: calc((var(--v-activated-opacity) + var(--v-hover-opacity)) * var(--v-theme-overlay-multiplier));\n}\n.v-expansion-panel-title--focusable.v-expansion-panel-title--active:focus-visible .v-expansion-panel-title__overlay {\n  opacity: calc((var(--v-activated-opacity) + var(--v-focus-opacity)) * var(--v-theme-overlay-multiplier));\n}\n@supports not selector(:focus-visible) {\n  .v-expansion-panel-title--focusable.v-expansion-panel-title--active:focus .v-expansion-panel-title__overlay {\n    opacity: calc((var(--v-activated-opacity) + var(--v-focus-opacity)) * var(--v-theme-overlay-multiplier));\n  }\n}\n\n.v-expansion-panel-title__overlay {\n  background-color: currentColor;\n  border-radius: inherit;\n  opacity: 0;\n}\n.v-expansion-panel-title__overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.v-expansion-panel-title__icon {\n  display: inline-flex;\n  margin-bottom: -4px;\n  margin-top: -4px;\n  user-select: none;\n  margin-inline-start: auto;\n}\n\n.v-expansion-panel-text {\n  display: flex;\n}\n.v-expansion-panel-text__wrapper {\n  padding: 8px 24px 16px;\n  flex: 1 1 auto;\n  max-width: 100%;\n}\n\n.v-expansion-panels--variant-accordion > .v-expansion-panel {\n  margin-top: 0;\n}\n.v-expansion-panels--variant-accordion > .v-expansion-panel::after {\n  opacity: 1;\n}\n\n.v-expansion-panels--variant-popout > .v-expansion-panel {\n  max-width: calc(100% - 32px);\n}\n.v-expansion-panels--variant-popout > .v-expansion-panel--active {\n  max-width: calc(100% + 16px);\n}\n\n.v-expansion-panels--variant-inset > .v-expansion-panel {\n  max-width: 100%;\n}\n.v-expansion-panels--variant-inset > .v-expansion-panel--active {\n  max-width: calc(100% - 32px);\n}\n\n.v-expansion-panels--flat > .v-expansion-panel::after {\n  border-top: none;\n}\n.v-expansion-panels--flat > .v-expansion-panel .v-expansion-panel__shadow {\n  display: none;\n}\n\n.v-expansion-panels--tile {\n  border-radius: 0;\n}\n.v-expansion-panels--tile > .v-expansion-panel {\n  border-radius: 0;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
